
import React from 'react';
import 'antd/dist/antd.css';
import ApiService from '../services/ApiService';
import removeObjectProperties from 'app/utils/RemoveObjectProperties';

import { Table, Input, Button, Modal, Form } from 'antd';

import { clearProcess, fetchProcess } from 'app/actions/ProcessActions';

const { confirm }=Modal;

const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      editing: false,
      inputValue:''
    };
  }

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing }, () => {
      if (editing) {
        this.input.focus();
      }
    });
  };

  save = e => {
      const { record, handleSave } = this.props;
      this.form.validateFields((error, values) => {
          if (error && error[e.currentTarget.id]) {
              return;
            }
            this.toggleEdit();
            handleSave({ ...record, ...values });
        });
  };

  renderCell = form => {
    this.form = form;
    const { children, dataIndex, record, title } = this.props;
    const { editing } = this.state;

    return editing ? (
      <Form.Item style={{ margin: 0 }}>
        {form.getFieldDecorator(dataIndex, {
          rules: [
            {
              required: true,
              message: `${title} es requerido.`,
            },
          ],
          initialValue: record[dataIndex],
        })(<Input ref={node => (this.input = node)}
         onPressEnter={this.save} 
         onBlur={this.save} 
         />)}
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{ paddingRight: 24 }}
        onClick={this.toggleEdit}
      >
        {children}
      </div>
    );
  };

  render() {
    const {
      editable,
      dataIndex,
      title,
      record,
      index,
      handleSave,
      children,
      ...restProps
    } = this.props;
    return this.state && (
        <td {...restProps}>
        {editable ? (
          <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
        ) : (
          children
        )}
      </td>
    );
}
}

export default class EditableTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataTable: [],
            row: EditableFormRow,
            cell: EditableCell,
            newData:[]
        }
    }
    
    handleDelete = key => {
        const dataSource = [...this.state.dataSource];
        this.setState({ dataSource: dataSource.filter(item => item.key !== key) });
    };
    
    clearAll = () => {
        const data={...this.props};
        confirm({
          title: '¿Eliminar datos la columna de "Nombre del procedimiento"?',
          okText: 'Eliminar',
          okType: 'danger',
          cancelText: 'Cancelar',
          onOk() {
            ApiService.deleteProcessById(data.formData.idCommunicationProgram, data.formData.idFront).then(
              ()=>{
                data.dispatch(clearProcess())
                data.dispatch(fetchProcess(data.formData, data.formData.idCommunicationProgram ))
              }
            )
          },
          onCancel() { },
      });
	};
	
	
    cancelAll = () => {
        const data={...this.props};
        confirm({
			title: '¿Cancelar edición de procedimientos?',
			okText: 'Cancelar',
			content: 'Se borrarán todos los cambios',
			cancelText: 'Continuar editando',
			onOk() {
				data.dispatch(clearProcess())
				data.dispatch(fetchProcess(data.formData, data.formData.idCommunicationProgram ))
			},
			onCancel() { },
      });
    };
    
    saveAll = () => {
      this.state.newData.forEach(i=>{
          return i['processName']=i.procedureName;
      })
      this.state.newData.forEach(i=>{
        removeObjectProperties(i, [ 'idCommunicationProgram','courseCode','courseName','processDescription', 'courseSupportFileDate','rownum','specialtyName', 'TotalRows', 'procedureName']);
      })
      const data = {...this.props}
      const newData=[...this.props.dataSource];
      confirm({
        title: '¿Guardar nombre(s) de procedimiento(s)?',
		    okText: 'Guardar',
        cancelText: 'Cancelar',
        onOk() {
          ApiService.setProcessbyId(newData, data.formData.idCommunicationProgram).then(
            ()=>{
              data.dispatch(clearProcess())
              data.dispatch(fetchProcess(data.formData, data.formData.idCommunicationProgram ))
            }
          )
        },
        onCancel() { },
    });
    };
    
    handleSave = row => {
        this.state.newData.push(row)
        this.props.dataSource.forEach(i=>{
          if(i.courseCode=== row.courseCode){
            i['processName']=row.processName;
            return i.processName=row.processName;
            
          }
        })
        this.setState({...row})
    };
    
    render() {
      const { dataSource } = this.props;
        const components = {
            body: {
                row: EditableFormRow,
                cell: EditableCell,
            },
        };
        const columns = this.props.columns.map(col => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    editable: col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: this.handleSave,
                }),
            };
        });
	return (
		<div>
			<Button onClick={this.clearAll} type="primary" style={{ marginBottom: 16, marginRight:16}}>
				Limpiar nombres del proceso
			</Button>
			<Button onClick={this.saveAll} type="primary" style={{ marginBottom: 16,  marginRight:16}}>
				Guardar
			</Button>
			<Button onClick={this.cancelAll} type="danger" ghost style={{ marginBottom: 16}}>
				Cancelar
			</Button>
			<Table
			components={components}
			rowClassName={() => 'editable-row'}
			dataSource={dataSource}
			columns={columns}
			pagination={this.props.pagination}
			scroll={{ y: 700}}
			loading={this.props.loading}
			onChange={this.props.onChange}
			/>
		</div>
    );
}
}